import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import { TitleComponent } from '_components/TitleComponent/TitleComponent';
import {ActionButtons} from "_components/ActionButtons/ActionButtons";
import {PageCopy} from "_components/PageCopy/PageCopy";
import {PromocracyLogo} from "_components/PromocracyLogo/PromocracyLogo";
import PageFlow from "_pages/__routes/PageFlow";
import {CustomContent} from '_pages/Variations/CustomContent/CustomContent';
import {PageBackgroundImages} from "_components/PageBackgroundImages/PageBackgroundImages";

import { executeAction } from "__globals/appActions";

import {
    empty,
    logIt
} from '__globals/global-functions';
import * as GC from "__globals/GLOBAL-CONSTANTS";
import {PAGE_ENTER_CODES} from "__globals/GLOBAL-CONSTANTS";
import {processClearEntryUpdated, processErrMsgDisplay, updateEntry} from "../../../_features/entries/entry-slice";
import {addCSSClass, removeCSSClass} from "../../../__globals/css-functions";

export const EnterCodes = props => {

    logIt(GC.PAGE_ENTER_CODES + " PAGE IS CALLED", null, false);
    const PAGE_DIV_NAME = "enter_codes"; // use underscores
    const PAGE_KEY = "enterCodes"; // use camel case
    const PAGE_IMAGE_KEY = "enter-codes"; // use dashes
    const PAGE_JSON_KEY = "EnterCodes"; // use init caps

    const dispatch = useDispatch();

    const promotion = useSelector(state => state.promotion);
    //logIt( "PROMOTION at " + GC.PAGE_TEMPLATE, promotion, true );

    let entry = useSelector(state => state.entry);
    //logIt( "ENTRY at IWGameMatch", entry, true);

    let entryUpdated = useSelector(state => state.entry.entryUpdated);
    //logIt( "entryUpdated AT PickYourPrize", error, true );

    let error = useSelector(state => state.entry.error);
    logIt( "ERROR AT " + GC.PAGE_ENTER_CODES, error, true );

    // LOCAL VARIABLES
    const [action, setAction] = useState('');
    const [value, setValue] = useState('');
    const [goNext, setGoNext] = useState(false);

    const[maxCards, setMaxCards] = useState(0);
    const [countList, setCountList] = useState( [
        {"key":"1","value":"I have 1 card"},
        {"key":"2","value":"I have 2 cards"},
        {"key":"3","value":"I have 3 cards"},
        {"key":"4","value":"I have 4 cards"},
        {"key":"5","value":"I have 5 cards"},
        {"key":"6","value":"I have 6 cards"},
        {"key":"7","value":"I have 7 cards"},
        {"key":"8","value":"I have 8 cards"},
        {"key":"9","value":"I have 9 cards"},
        {"key":"10","value":"I have 10 cards"}
    ] );

    const [currentCount, setCurrentCount] = useState('0');
    const onChangeCurrentCount = e => {
        //alert(e.target.value);
        //props.handleSelectChange( props.name, props.dependent );
        setCurrentCount(e.target.value) ;
    }

    // TODO: Clean this up and make it some kind of loop
    const [showEntry1, setShowEntry1] = useState( false );
    const [code1, setCode1] = useState( '' );
    const onChangeCodeEntry1 = e => { setCode1(e.target.value) }

    const [showEntry2, setShowEntry2] = useState( false );
    const [code2, setCode2] = useState( '' );
    const onChangeCodeEntry2 = e => { setCode2(e.target.value) }

    const [showEntry3, setShowEntry3] = useState( false );
    const [code3, setCode3] = useState( '' );
    const onChangeCodeEntry3 = e => { setCode3(e.target.value) }

    const [showEntry4, setShowEntry4] = useState( false );
    const [code4, setCode4] = useState( '' );
    const onChangeCodeEntry4 = e => { setCode4(e.target.value) }

    const [showEntry5, setShowEntry5] = useState( false );
    const [code5, setCode5] = useState( '' );
    const onChangeCodeEntry5 = e => { setCode5(e.target.value) }

    const [showEntry6, setShowEntry6] = useState( false );
    const [code6, setCode6] = useState( '' );
    const onChangeCodeEntry6 = e => { setCode6(e.target.value) }

    const [showEntry7, setShowEntry7] = useState( false );
    const [code7, setCode7] = useState( '' );
    const onChangeCodeEntry7 = e => { setCode7(e.target.value) }

    const [showEntry8, setShowEntry8] = useState( false );
    const [code8, setCode8] = useState( '' );
    const onChangeCodeEntry8 = e => { setCode8(e.target.value) }

    const [showEntry9, setShowEntry9] = useState( false );
    const [code9, setCode9] = useState( '' );
    const onChangeCodeEntry9 = e => { setCode9(e.target.value) }

    const [showEntry10, setShowEntry10] = useState( false );
    const [code10, setCode10] = useState( '' );
    const onChangeCodeEntry10 = e => { setCode10(e.target.value) }

    const setErrorMsgDisplay = (errMsg) => {
        dispatch( processErrMsgDisplay(errMsg) );
    }

    const submitCodes = () => {
        if ( !validateCodeSubmit() ) {
            return;
        }
        let addEntry = {"entry":{}};
        if ( !empty(code1) )  {
            addEntry.entry.entryCode1 = code1;
            logIt( "ENTERED CODE 1: ", code1, false );
        }
        if ( !empty(code2) )  {
            addEntry.entry.entryCode2 = code2;
            logIt( "ENTERED CODE 1: ", code2, false );
        }
        if ( !empty(code3) )  {
            addEntry.entry.entryCode3 = code3;
            logIt( "ENTERED CODE 3: ", code3, false );
        }
        if ( !empty(code4) )  {
            addEntry.entry.entryCode4 = code4;
            logIt( "ENTERED CODE 4: ", code4, false );
        }
        if ( !empty(code5) )  {
            addEntry.entry.entryCode5 = code5;
            logIt( "ENTERED CODE 5: ", code5, false );
        }
        if ( !empty(code6) )  {
            addEntry.entry.entryCode6 = code6;
            logIt( "ENTERED CODE 6: ", code6, false );
        }
        if ( !empty(code7) )  {
            addEntry.entry.entryCode7 = code7;
            logIt( "ENTERED CODE 7: ", code7, false );
        }
        if ( !empty(code8) )  {
            addEntry.entry.entryCode8 = code8;
            logIt( "ENTERED CODE 8: ", code8, false );
        }
        if ( !empty(code9) )  {
            addEntry.entry.entryCode9 = code9;
            logIt( "ENTERED CODE 9: ", code9, false );
        }
        if ( !empty(code10) )  {
            addEntry.entry.entryCode10 = code10;
            logIt( "ENTERED CODE 10: ", code10, false );
        }
        dispatch( updateEntry(addEntry) );
    }

    const has8digits = (codeToCheck) => {
        if (codeToCheck.length !== 8) {
            return false;
        }
        return true;
    }
    const validateCodeSubmit = () => {
        let valMessage = validate( "codes" );
        if ( valMessage == "" ) {
            valMessage = validate("digits");
        }
        if ( valMessage !== "" ) {
            setErrorMsgDisplay( valMessage );
            return false;
        }
        return true;
    }

    const validate = (dialog) => {

        // codes
        if ( dialog === "codes" ) {
            removeCSSClass("dv_code_1", "form-error");
            if ( showEntry1 && empty(code1) ) {
                addCSSClass("dv_code_1", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
            removeCSSClass("dv_code_2", "form-error");
            if ( showEntry2 && empty(code2) ) {
                addCSSClass("dv_code_2", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
            removeCSSClass("dv_code_3", "form-error");
            if ( showEntry3 && empty(code3) ) {
                addCSSClass("dv_code_3", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
            removeCSSClass("dv_code_4", "form-error");
            if ( showEntry4 && empty(code4) ) {
                addCSSClass("dv_code_4", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
            removeCSSClass("dv_code_5", "form-error");
            if ( showEntry5 && empty(code5) ) {
                addCSSClass("dv_code_5", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
            removeCSSClass("dv_code_6", "form-error");
            if ( showEntry6 && empty(code6) ) {
                addCSSClass("dv_code_6", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
            removeCSSClass("dv_code_7", "form-error");
            if ( showEntry7 && empty(code7) ) {
                addCSSClass("dv_code_7", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
            removeCSSClass("dv_code_8", "form-error");
            if ( showEntry8 && empty(code8) ) {
                addCSSClass("dv_code_8", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
            removeCSSClass("dv_code_9", "form-error");
            if ( showEntry9 && empty(code9) ) {
                addCSSClass("dv_code_9", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
            removeCSSClass("dv_code_10", "form-error");
            if ( showEntry10 && empty(code10) ) {
                addCSSClass("dv_code_10", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return "Please enter all codes";
            }
        }

        // digits
        if ( dialog === "digits" ) {
            let DIGIT_MSG = "Your code must have 8 digits";
            removeCSSClass("dv_code_1", "form-error");
            if ( showEntry1 && !has8digits(code1) ) {
                addCSSClass("dv_code_1", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
            removeCSSClass("dv_code_2", "form-error");
            if ( showEntry2 && !has8digits(code2) ) {
                addCSSClass("dv_code_2", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
            removeCSSClass("dv_code_3", "form-error");
            if ( showEntry3 && !has8digits(code3) ) {
                addCSSClass("dv_code_3", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
            removeCSSClass("dv_code_4", "form-error");
            if ( showEntry4 && !has8digits(code4) ) {
                addCSSClass("dv_code_4", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
            removeCSSClass("dv_code_5", "form-error");
            if ( showEntry5 && !has8digits(code5) ) {
                addCSSClass("dv_code_5", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
            removeCSSClass("dv_code_6", "form-error");
            if ( showEntry6 && !has8digits(code6) ) {
                addCSSClass("dv_code_6", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
            removeCSSClass("dv_code_7", "form-error");
            if ( showEntry7 && !has8digits(code7) ) {
                addCSSClass("dv_code_7", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
            removeCSSClass("dv_code_8", "form-error");
            if ( showEntry8 && !has8digits(code8) ) {
                addCSSClass("dv_code_8", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
            removeCSSClass("dv_code_9", "form-error");
            if ( showEntry9 && !has8digits(code9) ) {
                addCSSClass("dv_code_9", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
            removeCSSClass("dv_code_10", "form-error");
            if ( showEntry10 && !has8digits(code10) ) {
                addCSSClass("dv_code_10", "form-error");
                //return fieldsInUse.uploadPage.fileName.errorMsg[currentLanguage];
                return DIGIT_MSG;
            }
        }
        // caption
        // if ( dialog === "upload" ) {
        //     removeCSSClass("caption", "form-error");
        //     if ( caption === '' || caption === undefined ) {
        //         addCSSClass("caption", "form-error");
        //         return fieldsInUse.uploadPage.caption.errorMsg[currentLanguage];
        //     }
        // }
        // usage rights
        // if ( dialog === "upload" ) {
        //     removeCSSClass("usage_rights", "form-error");
        //     if ( usageRights === false || usageRights === undefined ) {
        //         addCSSClass("usage_rights", "form-error");
        //         return fieldsInUse.uploadPage.usageRights.errorMsg[currentLanguage];
        //     }
        // }
        return "";
    }

    useEffect(() => {
        //alert("in")
        if ( !empty(error) && !empty(error.errors) && !empty(error.errors[0]?.message) ) {
            //alert(error.errors[0]?.message)
            setErrorMsgDisplay( error.errors[0].message );
        }
    }, [error]);

    const getOptions = () => {
        let index = -1;
        let items = countList.map((option, key) => {
            return (
                <option value={option.key} key={option.key}>{option.value}</option>
            );
        });
        return items;
    }

    useEffect(() => {
        if ( !empty(promotion) ) {
            let c = promotion.configuration?.config?.variations["enterCodes"]["maxCodes"];
        }
    }, [promotion] );

    useEffect(() => {
        if ( !empty(currentCount) && (currentCount > 0) ) {
            if ( currentCount >= 1 ) { setShowEntry1( true ); } else { setShowEntry1( false ); }
            if ( currentCount >= 2 ) { setShowEntry2( true ); } else { setShowEntry2( false ); }
            if ( currentCount >= 3 ) { setShowEntry3( true ); } else { setShowEntry3( false ); }
            if ( currentCount >= 4 ) { setShowEntry4( true ); } else { setShowEntry4( false ); }
            if ( currentCount >= 5 ) { setShowEntry5( true ); } else { setShowEntry5( false ); }
            if ( currentCount >= 6 ) { setShowEntry6( true ); } else { setShowEntry6( false ); }
            if ( currentCount >= 7 ) { setShowEntry7( true ); } else { setShowEntry7( false ); }
            if ( currentCount >= 8 ) { setShowEntry8( true ); } else { setShowEntry8( false ); }
            if ( currentCount >= 9 ) { setShowEntry9( true ); } else { setShowEntry9( false ); }
            if ( currentCount >= 10 ) { setShowEntry10( true ); } else { setShowEntry10( false ); }
        }
    }, [currentCount] );

    useEffect(() => {
        if ( !empty(entry) && !empty(code1) ) {
            if ( entryUpdated) {
                dispatch( processClearEntryUpdated() );
            } else {
                setGoNext( true );
            }
        }
    }, [entryUpdated] );

    const doAction = (a, v) => {
        if (a.toUpperCase().trim() === GC.ACTION_NAVIGATE) {
            setAction(a);
            setValue(v);
            setGoNext(true);
        } else {
            //dispatch(executeAction(a, v));
        }
    }

    if (goNext) {

        return (<PageFlow page={GC.PAGE_ENTER_CODES} error={null} action={action} value={value}/>);

    } else {

        return (
            <React.Fragment>
                <TitleComponent title={promotion.configuration.promoCopy.GLOBAL.title}/>
                <div id={PAGE_DIV_NAME + "_page"}>

                    <table>
                        <tbody>
                        <tr>
                            <td className="page-visual">

                                <PageBackgroundImages
                                    promotion={promotion}
                                    pageKey={PAGE_IMAGE_KEY}
                                />

                            </td>
                            <td className="page-content">

                                <div id={PAGE_DIV_NAME + "_content"}>

                                    <PageCopy
                                        promotion={promotion}
                                        configKey={PAGE_KEY}
                                        jsonKey={PAGE_JSON_KEY}
                                    />

<div id={"dv_enter_codes_controls"} className={"cls-enter-codes-controls"}>

    <div id="dv_enter_codes_select" className="select-wrapper">
        <select
            className="NOTselected"
            id="select"
            name="codeCount"
            tabIndex="1"
            value={currentCount}
            onChange={onChangeCurrentCount}
            required>
            <option value='0' key='0'>Select Number of Cards</option>
            {getOptions()}
        </select>
    </div>

    <div id={"dv_code_entries"}>
        {showEntry1 && 	<div id={"dv_code_1"}><input name={"codeEntryBox1"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry1} /></div>}
        {showEntry2 && 	<div id={"dv_code_2"}><input name={"codeEntryBox2"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry2} /></div>}
        {showEntry3 && 	<div id={"dv_code_3"}><input name={"codeEntryBox3"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry3} /></div>}
        {showEntry4 && 	<div id={"dv_code_4"}><input name={"codeEntryBox4"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry4} /></div>}
        {showEntry5 && 	<div id={"dv_code_5"}><input name={"codeEntryBox5"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry5} /></div>}
        {showEntry6 && 	<div id={"dv_code_6"}><input name={"codeEntryBox6"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry6} /></div>}
        {showEntry7 && 	<div id={"dv_code_7"}><input name={"codeEntryBox7"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry7} /></div>}
        {showEntry8 && 	<div id={"dv_code_8"}><input name={"codeEntryBox8"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry8} /></div>}
        {showEntry9 && 	<div id={"dv_code_9"}><input name={"codeEntryBox9"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry9} /></div>}
        {showEntry10 && <div id={"dv_code_10"}><input name={"codeEntryBox10"} type="text" placeholder="EIGHT-DIGIT CODE" maxlength="8" onChange={onChangeCodeEntry10} /></div>}
    </div>

    { !empty(entry.errorMsgDisplay) ? (
        <div class="error">{entry.errorMsgDisplay}</div>
    ) : (
        <div class="error"></div>
    )}

    <div id="enter_codes_button" onClick={submitCodes}>Submit Codes</div>

</div>


                                    <ActionButtons
                                        promotion={promotion}
                                        configKey={PAGE_KEY}
                                        jsonKey={PAGE_JSON_KEY}
                                        doAction={doAction}
                                    />

                                </div>

                                <PromocracyLogo promotion={promotion}/>

                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <CustomContent/>

                </div>

            </React.Fragment>

        );

    }

}